import React from 'react';
import UnderConstruction from '../../components/molecules/UnderConstruction.jsx';

function OCIReports() {
  return (
    <UnderConstruction title="OCI Reports" />
  );
}

export default OCIReports;


